var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.99992 3.16659C4.99992 4.45525 3.95525 5.49992 2.66659 5.49992C1.37792 5.49992 0.333252 4.45525 0.333252 3.16659C0.333252 1.87792 1.37792 0.833252 2.66659 0.833252C3.95525 0.833252 4.99992 1.87792 4.99992 3.16659ZM4.99992 8.41658V24.1666H0.333252V8.41658H4.99992ZM8.49992 8.41658H13.1666V9.39823C13.8964 9.14028 14.6818 8.99992 15.4999 8.99992C19.3659 8.99992 22.4999 12.1339 22.4999 15.9999V24.1666H17.8333V15.9999C17.8333 14.7113 16.7886 13.6666 15.4999 13.6666C14.2113 13.6666 13.1666 14.7113 13.1666 15.9999V24.1666H8.49992V15.9999V8.41658Z","fill":"white"}));
}

Linkedin.defaultProps = {"width":"23","height":"25","viewBox":"0 0 23 25","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
